export default "__VITE_ASSET__MSid64yk__"